export const CEFSHARP_UPDATE_REJECTION_PATTERN =
  /^(?:Non-Error promise rejection captured with value: )?Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+$/

export function isCefSharpUpdateRejection(reason) {
  const message = (
    reason && typeof reason === 'object' && typeof reason.message === 'string'
  )
    ? reason.message
    : (typeof reason === 'string' ? reason : '')

  return CEFSHARP_UPDATE_REJECTION_PATTERN.test(message)
}
